
(function () {
  'use strict';

  var TEXTE = null;
  function tx(k, rueckfall, werte) {
    if (!TEXTE) {
      try {
        var el = document.querySelector('script[data-setup-texte]');
        if (el) TEXTE = JSON.parse(el.textContent) || {};
      } catch (e) { TEXTE = {}; }
    }
    var s = (TEXTE && TEXTE[k]) || rueckfall || '';
    if (werte) {
      s = s.replace(/\{(\w+)\}/g, function (m, n) { return werte[n] != null ? String(werte[n]) : m; });
    }
    return s;
  }

  var HOECHSTZAHL = 4;
  var PROXY_STANDARD = '/apps/monitor-db';

  var MONITOR_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"'
    + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<rect x="3" y="4" width="18" height="12" rx="2"></rect>'
    + '<path d="M9 20h6M12 16v4"></path></svg>';

  var KOPIE_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"'
    + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<rect x="9" y="9" width="11" height="11" rx="2"></rect>'
    + '<path d="M5 15V5a2 2 0 0 1 2-2h10"></path></svg>';

  var TONNE_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"'
    + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="M4 7h16M10 11v6M14 11v6"></path>'
    + '<path d="M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12"></path>'
    + '<path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path></svg>';

  var fenster = null;
  var arbeit = [];
  var daten = {};
  var uhr = null, letzte = '';
  var mitTisch = false, tischArbeit;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function proxy() {
    return (window.FinderClean && window.FinderClean.proxy) || PROXY_STANDARD;
  }

  function abruf(url) {
    if (window.EngineStatus) return window.EngineStatus.hol(url);
    return fetch(url).then(function (r) { return r.json(); });
  }

  function ausfall(e) {
    return !!(e && e.engineAus && window.EngineStatus);
  }

  function waText() { return tx('stf_wa_text', 'Hallo, ich suche eine Halterung. Mein Monitor ist: '); }

  function bildAdresse(u) {
    if (typeof u !== 'string' || !u) return '';
    return u.indexOf('/media/') === 0 ? proxy() + u : u;
  }

  function zahl(n) {
    return String(Math.round(n * 10) / 10).replace('.', ',');
  }

  function aufFinderSeite() {
    return !!document.querySelector('.fn-finder, [data-role="one-wrap"]');
  }

  function ladeArbeit() {
    arbeit = [];
    try {
      var roh = JSON.parse(localStorage.getItem('3idee_auswahl') || 'null');
      if (!roh || !roh.refs) return;
      var namen = roh.namen && roh.namen.length ? roh.namen : [roh.name || ''];
      roh.refs.forEach(function (ref, i) {
        arbeit.push({ ref: String(ref), name: namen[i] || ('Monitor ' + (i + 1)) });
      });
    } catch (e) {}
  }

  function speichern() {
    try {
      var alt = null;
      try { alt = JSON.parse(localStorage.getItem('3idee_auswahl') || 'null'); } catch (x) {}

      var tischNeu = tischArbeit !== undefined ? tischArbeit : ((alt && alt.tisch) || null);
      if (!arbeit.length && mitTisch && tischNeu) {
        localStorage.setItem('3idee_auswahl', JSON.stringify({
          refs: [], namen: [], anzahl: 0, mount: (alt && alt.mount) || '',
          tisch: tischNeu, pfad: location.pathname, zeit: Date.now() }));
      } else if (!arbeit.length) {
        localStorage.removeItem('3idee_auswahl');
        try {
          Object.keys(sessionStorage).forEach(function (k) {
            if (k.indexOf('fn3state:') === 0) sessionStorage.removeItem(k);
          });
        } catch (x) {}
      } else {
        localStorage.setItem('3idee_auswahl', JSON.stringify({
          refs: arbeit.map(function (e) { return e.ref; }),
          name: arbeit[0].name,
          namen: arbeit.map(function (e) { return e.name; }),
          anzahl: arbeit.length,
          mount: (alt && alt.mount) || '',
          tisch: tischArbeit !== undefined ? tischArbeit : ((alt && alt.tisch) || null),
          pfad: location.pathname,
          zeit: Date.now()
        }));
      }
      document.dispatchEvent(new CustomEvent('finder:auswahl'));
    } catch (e) {}
  }

  function datenHolen(ref) {
    if (daten[ref]) return Promise.resolve(daten[ref]);
    return abruf(proxy() + '/monitors/' + encodeURIComponent(ref))
      .then(function (json) {
        var d = (json && json.ok && json.data) || {};
        daten[ref] = {
          bild: bildAdresse(d.image_url),
          groesse: d.size_inch ? zahl(d.size_inch) + '"' : '',
          gewicht: d.weight_g ? zahl(d.weight_g / 1000) + ' kg' : '',
          vesa: d.vesa || null
        };
        return daten[ref];
      })
      .catch(function () { daten[ref] = { bild: '', groesse: '', gewicht: '', vesa: null }; return daten[ref]; });
  }

  function bildHtml(ref) {
    var d = daten[ref];
    return '<span class="stf__bild">'
      + (d && d.bild ? '<img src="' + esc(d.bild) + '" alt="" loading="lazy">' : MONITOR_SVG)
      + '</span>';
  }

  function novesaWort() {
    var l = fenster && fenster.querySelector('[data-stf-liste]');
    return (l && l.getAttribute('data-stf-novesa')) || 'Kein VESA';
  }

  function vesaChip(ref) {
    var v = (daten[ref] || {}).vesa;
    if (!v) return '';
    if (v.mount === 'NO') {
      return '<span class="fn-vesa-chip is-static is-none"><span>'
           + esc(novesaWort())
           + '</span></span>';
    }
    if (v.patterns && v.patterns.length) {
      return '<span class="fn-vesa-chip is-static is-ok"><span>'
           + esc('VESA ' + v.patterns[0]) + '</span></span>';
    }
    return '';
  }

  function zeileHtml(e, i) {
    var d = daten[e.ref] || {};
    var unten = [d.groesse, d.gewicht].filter(Boolean).join(' · ');
    return '<div class="stf__zeile">'
      + bildHtml(e.ref)
      + '<span class="stf__txt">'
      +   '<span class="stf__name">' + esc(e.name) + '</span>'
      +   '<span class="stf__daten">' + esc(unten) + '</span>'
      + '</span>'
      + vesaChip(e.ref)
      + '<button class="stf__tat" type="button" data-stf-kopie="' + i + '"'
      +   ' aria-label="' + esc(tx('duplizieren', 'Monitor duplizieren')) + '"'
      +   (arbeit.length >= HOECHSTZAHL ? ' disabled' : '') + '>' + KOPIE_SVG + '</button>'
      + '<button class="stf__tat" type="button" data-stf-raus="' + i + '"'
      +   ' aria-label="' + esc(tx('entfernen', 'Monitor entfernen')) + '">' + TONNE_SVG + '</button>'
      + '</div>';
  }

  function zeichnen() {
    if (!fenster) return;
    var liste = fenster.querySelector('[data-stf-liste]');
    var mehr = fenster.querySelector('[data-stf-mehr]');
    var form = fenster.querySelector('[data-stf-form]');

    var titel = fenster.querySelector('[data-stf-titel]');
    if (titel) {
      titel.textContent = (arbeit.length === 1)
        ? (titel.getAttribute('data-stf-einer') || 'Dein Monitor')
        : (titel.getAttribute('data-stf-mehrere') || 'Deine Monitore');
    }

    liste.innerHTML = arbeit.length
      ? arbeit.map(zeileHtml).join('')
      : '<p class="stf__leer">' + esc(tx('stf_leer', 'Noch kein Monitor hinterlegt.')) + '</p>';

    var voll = arbeit.length >= HOECHSTZAHL;
    if (mehr) mehr.hidden = voll || (form && !form.hidden);
    if (voll && form) form.hidden = true;

    var hinweis = fenster.querySelector('[data-stf-hinweis]');
    if (hinweis) {
      hinweis.innerHTML = voll
        ? '<b>' + esc(tx('stf_voll_titel', '{n} Monitore sind das Höchste', { n: HOECHSTZAHL })) + '</b>'
          + esc(tx('stf_voll_text', 'Entferne einen, um Platz für ein anderes Gerät zu machen.'))
        : '<b>' + esc(tx('stf_bis_titel', 'Bis zu {n} Monitore', { n: HOECHSTZAHL })) + '</b>'
          + esc(tx('stf_bis_text', 'Auch unterschiedliche Modelle. Jeder wird einzeln geprüft und '
          + 'anschließend im gemeinsamen Setup berücksichtigt.'));
    }

    if (window.EngineStatus && window.EngineStatus.gestoert()) {
      if (mehr) mehr.hidden = true;
      if (form) form.hidden = true;
      if (hinweis) {
        hinweis.innerHTML = window.EngineStatus.hinweisHtml(
          tx('stf_stoerung', 'Weitere Monitore lassen sich gerade nicht hinzufügen — die Modellsuche ist '
          + 'nicht erreichbar. Deine hinterlegten Geräte bleiben erhalten.'),
          waText());
      }
    }

    var offen = arbeit.filter(function (e) { return !daten[e.ref]; });
    if (offen.length) {
      Promise.all(offen.map(function (e) { return datenHolen(e.ref); })).then(zeichnen);
    }
  }

  function tischZeigen() {
    var feld = fenster && fenster.querySelector('[data-stf-tisch-feld]');
    if (!feld) return;
    feld.hidden = !mitTisch;
    if (!mitTisch) return;
    var t = null;
    try { t = (JSON.parse(localStorage.getItem('3idee_auswahl') || 'null') || {}).tisch || null; } catch (e) {}
    var sel = feld.querySelector('[data-tsa-art]'), num = feld.querySelector('[data-tsa-dicke]');
    if (sel) sel.value = (t && t.gruppe) || '';
    if (num) num.value = (t && t.dicke_cm) || '';
    var weg = feld.querySelector('[data-tsa-weg]');
    if (weg) weg.hidden = !((sel && sel.value) || (num && num.value));
  }
  document.addEventListener('stf:tisch', function (e) { tischArbeit = e.detail || null; });

  function suchen(q) {
    var treffer = fenster.querySelector('[data-stf-treffer]');
    if (!treffer) return;

    abruf(proxy() + '/monitors/search?q=' + encodeURIComponent(q))
      .then(function (json) {
        if (q !== letzte) return;
        var d = (json && json.data) || {};
        var liste = (d.found && d.results && d.results.length) ? d.results : (d.similar || []);
        if (!json || !json.ok || !liste.length) {
          treffer.innerHTML = '<p class="stf__leer-treffer">' + esc(tx('kein_treffer', 'Kein Treffer')) + '</p>';
          treffer.hidden = false;
          return;
        }
        treffer.innerHTML = liste.slice(0, 8).map(function (m) {
          var zus = [];
          if (m.size_inch) zus.push(zahl(m.size_inch) + '"');
          if (m.year) zus.push(m.year);
          var bild = bildAdresse(m.image_url);
          return '<button type="button" data-stf-ref="' + esc(m.ref) + '"'
            + ' data-stf-name="' + esc(m.name) + '">'
            + '<span class="stf__bild">'
            +   (bild ? '<img src="' + esc(bild) + '" alt="" loading="lazy">' : MONITOR_SVG)
            + '</span>'
            + '<span>' + esc(m.name)
            + (zus.length ? ' <small>' + esc(zus.join(' · ')) + '</small>' : '')
            + '</span></button>';
        }).join('');
        treffer.hidden = false;
      })
      .catch(function (e) {
        if (q !== letzte) return;
        if (ausfall(e)) {
          treffer.innerHTML = window.EngineStatus.hinweisHtml(
            tx('suche_stoerung', 'Die Modellsuche ist gerade nicht erreichbar. Schreib uns dein Modell — wir sagen dir sofort, was passt.'),
            waText());
          treffer.hidden = false;
          return;
        }
        treffer.hidden = true;
      });
  }

  function feldSchliessen() {
    if (!fenster) return;
    var form = fenster.querySelector('[data-stf-form]');
    var treffer = fenster.querySelector('[data-stf-treffer]');
    var feld = fenster.querySelector('[data-stf-eingabe]');
    if (form) form.hidden = true;
    if (treffer) { treffer.hidden = true; treffer.innerHTML = ''; }
    if (feld) feld.value = '';
    letzte = '';
  }

  document.addEventListener('click', function (e) {
    var ziel = e.target.closest && e.target.closest('[data-fenster-auf="setup"]');
    if (!ziel) return;

    if (aufFinderSeite()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      document.dispatchEvent(new CustomEvent('finder:einstieg'));
      var liste = document.querySelector('[data-role="block-monitore"]')
               || document.querySelector('.fn-section');
      if (liste && liste.scrollIntoView) {
        setTimeout(function () { liste.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
      }
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    if (!fenster || !fenster.showModal || fenster.open) return;
    mitTisch = true;
    tischArbeit = undefined;
    ladeArbeit();
    feldSchliessen();
    tischZeigen();
    zeichnen();
    fenster.showModal();
  }, true);

  document.addEventListener('click', function (e) {

    if (!fenster || !fenster.open) return;

    var kopie = e.target.closest && e.target.closest('[data-stf-kopie]');
    if (kopie) {
      var ik = Number(kopie.getAttribute('data-stf-kopie'));
      if (arbeit[ik] && arbeit.length < HOECHSTZAHL) {
        arbeit.splice(ik + 1, 0, { ref: arbeit[ik].ref, name: arbeit[ik].name });
      }
      zeichnen();
      return;
    }

    var raus = e.target.closest && e.target.closest('[data-stf-raus]');
    if (raus) {
      arbeit.splice(Number(raus.getAttribute('data-stf-raus')), 1);
      zeichnen();
      return;
    }

    if (e.target.closest && e.target.closest('[data-stf-mehr]')) {
      var form = fenster.querySelector('[data-stf-form]');
      var feld = fenster.querySelector('[data-stf-eingabe]');
      if (form) form.hidden = false;
      var mehr = fenster.querySelector('[data-stf-mehr]');
      if (mehr) mehr.hidden = true;
      if (feld) feld.focus();
      return;
    }

    var wahl = e.target.closest && e.target.closest('[data-stf-ref]');
    if (wahl) {
      if (arbeit.length < HOECHSTZAHL) {
        arbeit.push({
          ref: String(wahl.getAttribute('data-stf-ref')),
          name: wahl.getAttribute('data-stf-name')
        });
      }
      feldSchliessen();
      zeichnen();
      return;
    }

    if (e.target.closest && e.target.closest('[data-stf-ok]')) {
      speichern();
      fenster.close();
    }
  });

  document.addEventListener('input', function (e) {
    var feld = e.target.closest && e.target.closest('[data-stf-eingabe]');
    if (!feld) return;
    var q = feld.value.trim();
    letzte = q;
    clearTimeout(uhr);
    if (q.length < 2) {
      var treffer = fenster.querySelector('[data-stf-treffer]');
      if (treffer) treffer.hidden = true;
      return;
    }
    uhr = setTimeout(function () { suchen(q); }, 180);
  });

  document.addEventListener('submit', function (e) {
    if (!e.target.closest || !e.target.closest('[data-stf-form]')) return;
    e.preventDefault();
    var feld = fenster.querySelector('[data-stf-eingabe]');
    var q = feld ? feld.value.trim() : '';
    letzte = q;
    if (q.length >= 2) suchen(q);
  });

  document.addEventListener('engine:status', function () {
    if (fenster && fenster.open) zeichnen();
  });

  function start() {
    fenster = document.querySelector('[data-fenster="setup"]');
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
